module.exports = __webpack_public_path__ + "img/icon_title.03e471dc.png";